import React,{useState,useEffect} from "react"
import EditButton from "./EditButton";
import { useGlobal } from "./Reducer";
import Api from "./Api";
import _ from "lodash"
export default (props)=>{



    const [gs,ga]=useGlobal();
    const [POLL,setPOLL]=useState({})
    const [OPTIONS,setOPTIONS]=useState([]);

    useEffect(()=>{
            ga.loading(true);
        
            Api.getPreviosPollAndOptions(gs.appData.id).then(({POLL,OPTIONS})=>{
                    setPOLL(POLL||{});
                    let total=0;
                    _.each(OPTIONS,option=>{
                        total+=parseFloat(option.votes+"");
                    });
                    _.each(OPTIONS,option=>{
                        option.pert=option.votes/total*100;    
                    });
                    setOPTIONS(OPTIONS);
            }).finally(()=>{
                ga.loading(false);
            });;
    },[gs.appData.result_poll_id,gs.voted])



    return ( 
        <div>

<div className="changeable  hvr-shrink" ref_tag="poll_setter_result" id="poll_setter_result"
          style={{position:"absolute",right:4,top:-22}}
           data-toggle="tooltip" data-placement="left" title="Set Poll Result ">
                  <div className="globaleditbtn ">
                  {props.editButton}
              
                  </div>
              </div>
        
        <div className="whitebg boxed poll_result_news " ng-show="poll_result">
    <div className=" lvl1 blacktext">
 Poll Results
    </div>
    <div  id="votedareatitle">
            {POLL.title}
    </div>
    <div id="votedarea" 
    
    style={{textAlign:"left",padding:15}}
     className="text-left">
 
        {_.map(OPTIONS,(option,index)=>{
            return (<div key={index+":"+option.title} className="row"><div className="col-12 pollanswer" > {option.title}</div><div className="col-10">
            <div className=" row progress" style={{height:15}}>  <div className="progress-bar progress-bar-success" role="progressbar" aria-valuenow={option.pert} aria-valuemin="0" aria-valuemax="100" style={{width:option.pert+"%"}}> 
            </div></div></div><div className="col-2 percentage">{option.pert.toFixed(1)}%</div></div>);    
        })} 
    </div>
  
  </div></div>);
}





 